module.exports = __webpack_public_path__ + "img/credential13.8cd09626.png";